import { render, staticRenderFns } from "./syRoleAdmin.vue?vue&type=template&id=13ad4df2&scoped=true&"
import script from "./syRoleAdmin.vue?vue&type=script&lang=js&"
export * from "./syRoleAdmin.vue?vue&type=script&lang=js&"
import style0 from "./syRoleAdmin.vue?vue&type=style&index=0&id=13ad4df2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ad4df2",
  null
  
)

export default component.exports